import {Directive, Input} from '@angular/core';

@Directive()
export class ValueView {
  @Input() label: string;
  @Input() value: string;
}
